// ./src/components/shared/Sektor/timerState.js

import Vue from 'vue';

const FULL_CIRCLE = 360;
const DEFAULT_TIMEOUT = 30;

const state = Vue.observable({
  angle: FULL_CIRCLE,
  isVisible: false,
  timerId: null,
  timePassed: 0,
  timeout: DEFAULT_TIMEOUT,
});

const getters = {
  isVisible: () => state.isVisible,
  currentAngle: () => state.angle,
  angleStep: () => FULL_CIRCLE / state.timeout,
  timeLeft: () => state.timeout - state.timePassed,
};

const mutations = {
  toggleVisible() {
    state.isVisible = !state.isVisible;
  },

  show() {
    state.isVisible = true;
  },

  hide() {
    state.isVisible = false;
  },

  reset() {
    this.stop(false);
    state.angle = FULL_CIRCLE;
    state.timePassed = 0;
  },

  tick() {
    state.timePassed += 1; // plus 1 second
    state.angle = FULL_CIRCLE - state.timePassed * getters.angleStep();

    if (state.timePassed >= state.timeout) {
      this.stop(false);
    }
  },

  start({ timeout = DEFAULT_TIMEOUT, timePassed = 0 }) {
    console.log('Start -> ', timeout, timePassed);

    this.stop(false); // stop previous timer

    state.timeout = timeout;
    this.show();

    if (timePassed) {
      state.timePassed = timePassed;
    } else {
      this.reset();
    }

    if (getters.timeLeft() <= 0) {
      state.angle = 0;
      return;
    }

    state.timerId = setInterval(() => {
      this.tick();
    }, 1e3);
  },

  stop(hide = true) {
    if (state.timerId) {
      state.timerId = clearInterval(state.timerId);
    }

    if (hide) {
      this.hide();
    }
  },
};

export { getters, mutations };
